import { IComponentType, } from '@r3f-component-data-structure';
export var IToastType;
(function (IToastType) {
    IToastType["error"] = "error";
    IToastType["warning"] = "warning";
    IToastType["info"] = "info";
    IToastType["success"] = "success";
})(IToastType || (IToastType = {}));
export var IToastSize;
(function (IToastSize) {
    IToastSize["default"] = "default";
    IToastSize["mini"] = "mini";
})(IToastSize || (IToastSize = {}));
export var IToastContrast;
(function (IToastContrast) {
    IToastContrast["undefined"] = "undefined";
    IToastContrast["default"] = "default";
    IToastContrast["high"] = "high";
})(IToastContrast || (IToastContrast = {}));
export var ITransformControlsMode;
(function (ITransformControlsMode) {
    ITransformControlsMode["translate"] = "translate";
    ITransformControlsMode["rotate"] = "rotate";
    ITransformControlsMode["scale"] = "scale";
    ITransformControlsMode["curve"] = "curve";
})(ITransformControlsMode || (ITransformControlsMode = {}));
export var IProjectShelves;
(function (IProjectShelves) {
    IProjectShelves["backgroundSound"] = "backgroundSound";
    IProjectShelves["arWebEmbed"] = "arWebEmbed";
    IProjectShelves["targetNotSeen"] = "targetNotSeen";
    IProjectShelves["analytics"] = "analytics";
    IProjectShelves["shadows"] = "shadows";
    IProjectShelves["splashScreen"] = "splashScreen";
    IProjectShelves["grabNGo"] = "grabNGo";
    IProjectShelves["imageTrackingSettings"] = "imageTrackingSettings";
    IProjectShelves["worldTrackingSettings"] = "worldTrackingSettings";
    IProjectShelves["screenRelativeSettings"] = "screenRelativeSettings";
})(IProjectShelves || (IProjectShelves = {}));
export var ISceneShelves;
(function (ISceneShelves) {
    ISceneShelves["properties"] = "properties";
    ISceneShelves["transitions"] = "transitions";
    ISceneShelves["photoUi"] = "photoUi";
    ISceneShelves["screenSettings"] = "screenSettings";
    ISceneShelves["sceneActions"] = "sceneActions";
    ISceneShelves["content360"] = "content360";
    ISceneShelves["targetProperty"] = "targetProperty";
})(ISceneShelves || (ISceneShelves = {}));
export var IModal;
(function (IModal) {
    IModal["device"] = "device";
    IModal["template"] = "template";
    IModal["templateOverwrite"] = "templateOverwrite";
    IModal["avaturn"] = "avaturn";
    IModal["avaturnHelp"] = "avaturnHelp";
    IModal["mediaLibrary"] = "mediaLibrary";
    IModal["imageTrainer"] = "imageTrainer";
    IModal["particles"] = "particles";
    IModal["particlesHelp"] = "particlesHelp";
    IModal["imageTrackingPreview"] = "imageTrackingPreview";
    IModal["chromaKeyEdit"] = "chromaKeyEdit";
    IModal["chromaKeyHelp"] = "chromaKeyHelp";
    IModal["videoProcessingWarning"] = "videoProcessingWarning";
    IModal["customLaunchScreen"] = "customLaunchScreen";
    IModal["projectSizeLimit"] = "projectSizeLimit";
    IModal["appClips"] = "appClips";
    IModal["appClipsNoHideCheckbox"] = "appClipsNoHideCheckbox";
    IModal["targetImageModal"] = "targetImageModal";
    IModal["whatsNew"] = "whatsNew";
    IModal["sendFeedback"] = "sendFeedback";
    IModal["sessionExpired"] = "sessionExpired";
    IModal["authorizationDenied"] = "authorizationDenied";
})(IModal || (IModal = {}));
export var IScreenRelativeDevices;
(function (IScreenRelativeDevices) {
    IScreenRelativeDevices["IPHONE12"] = "IPHONE12";
    IScreenRelativeDevices["IPHONE8"] = "IPHONE8";
    IScreenRelativeDevices["PIXEL6a"] = "PIXEL6a";
    IScreenRelativeDevices["GALAXYS7"] = "GALAXYS7";
    IScreenRelativeDevices["IPAD"] = "IPAD";
    IScreenRelativeDevices["HORIZONTAL"] = "HORIZONTAL";
    IScreenRelativeDevices["CUSTOM"] = "CUSTOM";
})(IScreenRelativeDevices || (IScreenRelativeDevices = {}));
// TODO - This should be imported from web-components
export var IMediaCategory;
(function (IMediaCategory) {
    IMediaCategory["Audio"] = "Audio";
    IMediaCategory["Image"] = "Image";
    IMediaCategory["Video"] = "Video";
    IMediaCategory["Model3D"] = "3D";
    IMediaCategory["Content360"] = "360 content";
})(IMediaCategory || (IMediaCategory = {}));
export var IMediaLibraryOnSubmitCategory;
(function (IMediaLibraryOnSubmitCategory) {
    IMediaLibraryOnSubmitCategory["AddToScene"] = "AddToScene";
    IMediaLibraryOnSubmitCategory["ReplaceEntity"] = "ReplaceEntity";
    IMediaLibraryOnSubmitCategory["SelectChromaKeyVideo"] = "SelectChromaKeyVideo";
    IMediaLibraryOnSubmitCategory["AddIconToLaunchPage"] = "AddIconToLaunchPage";
})(IMediaLibraryOnSubmitCategory || (IMediaLibraryOnSubmitCategory = {}));
export const mediaLibraryCategoryByComponentType = {
    [IComponentType.Image]: IMediaCategory.Image,
    [IComponentType.Video]: IMediaCategory.Video,
    [IComponentType.Model3d]: IMediaCategory.Model3D,
};
export var IAudioStatus;
(function (IAudioStatus) {
    IAudioStatus["playing"] = "playing";
    IAudioStatus["paused"] = "paused";
    IAudioStatus["loading"] = "loading";
})(IAudioStatus || (IAudioStatus = {}));
export var ILaunchScreenIconSize;
(function (ILaunchScreenIconSize) {
    ILaunchScreenIconSize["medium"] = "Medium";
    ILaunchScreenIconSize["large"] = "Large";
})(ILaunchScreenIconSize || (ILaunchScreenIconSize = {}));
